import { render, staticRenderFns } from "./ItemManager.vue?vue&type=template&id=71018ad4&scoped=true"
import script from "./ItemManager.vue?vue&type=script&lang=ts"
export * from "./ItemManager.vue?vue&type=script&lang=ts"
import style0 from "./ItemManager.vue?vue&type=style&index=0&id=71018ad4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71018ad4",
  null
  
)

export default component.exports